import React, { Suspense } from "react";
import LoadPage from './LoadPage';

/**
 * Components to wrap around components that are lazily loaded.
 * Will render a default fallback whilst components are loaded.
 * See: https://reactjs.org/docs/code-splitting.html
 */
export default function LazyComponent({ children }) {

  function getFallback() {
    return(
      <LoadPage light={true} />
    );
  }

  return (
    <Suspense
     fallback = { getFallback() }
    >
      { children }
    </Suspense>
  );
}
